import type { IPerson } from '../model/IPerson'
import { MAX_AGE } from '../model/MAX_AGE'
import { formatNumber } from './formatNumber'
import { getAge } from './getAge'

export function getPersonAgeFormatted(person: IPerson) {
	const age = getAge(person.birthDate)
	return age != null && age <= MAX_AGE ? (
		<b>{formatNumber(age)} éves</b>
	) : undefined
}
